import React,{useState} from 'react';

type Props = {};

const UserAgentBlacklistPage = (props: Props) => {
  const [userAgents, setUserAgents] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setUserAgents(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Blacklisted User Agents:', userAgents);
    alert('Blacklisted User Agents Updated!');
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px',
    borderRadius: '0px',
    height: '80%',
  };

  const textAreaStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    backgroundColor: '#F5F5F5',
    minHeight: '150px',
    resize: 'none' as const,
  };

  const buttonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    width: '20%',
    marginTop: '10px',
  };

  const titleStyle = {
    fontSize: '14px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  const descriptionStyle = {
    fontSize: '12px',
    marginBottom: '15px',
  };

  const exampleStyle = {
    fontSize: '12px',
    fontWeight: 'bold' as const,
    marginBottom: '10px',
  };

  const noteStyle = {
    fontSize: '10px',
    marginTop: '10px',
    color: 'gray',
  };

  const userAgentExampleStyle = {
    fontFamily: 'monospace',
    fontSize: '12px',
    marginBottom: '5px',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '80%', textAlign: 'left', margin: '0 20px' }}>
        <h2 style={titleStyle}>Edit Your Blacklisted User Agents:</h2>
        <p style={descriptionStyle}>
          You have the optional possibility to blacklist user agents for all your campaigns. You will
          not receive any traffic from these user agents.
        </p>
        <p style={exampleStyle}>Examples:</p>
        <ul style={{ fontSize: '12px', marginBottom: '15px', paddingLeft: '20px' }}>
          <li>
            <span style={userAgentExampleStyle}>
              Mozilla/5.0 (compatible; MSIE 9.0; Windows NT 6.1; WOW64; Trident/5.0)
            </span>
          </li>
          <li>
            <span style={userAgentExampleStyle}>MSIE 9.0</span>
          </li>
          <li>
            <span style={userAgentExampleStyle}>9.0</span>
          </li>
        </ul>
        <form onSubmit={handleSubmit}>
          <textarea
            value={userAgents}
            onChange={handleInputChange}
            placeholder="Enter user agents, one per line"
            style={textAreaStyle}
          />
          <p style={noteStyle}>Maximum of 100 Entries</p>
          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserAgentBlacklistPage;